import React from 'react';
export type PathwayView = 'build' | 'saved';
interface PathwayViewToggleProps {
  view: PathwayView;
  /** Shows a dot on the build tab when there is unsaved work waiting there. */
  buildHasWork: boolean;
  onChange: (view: PathwayView) => void;
}
const TABS: {
  id: PathwayView;
  label: string;
}[] = [{
  id: 'build',
  label: 'Build A Pathway'
}, {
  id: 'saved',
  label: 'Pathway Library'
}];
export function PathwayViewToggle({
  view,
  buildHasWork,
  onChange
}: PathwayViewToggleProps) {
  return <div role="tablist" aria-label="Pathway Builder views" className="flex items-center border-b border-gray-200" data-id="element-1814" data-mp="2700veb82599p">
      {TABS.map(tab => {
      const active = view === tab.id;
      return <button key={tab.id} type="button" role="tab" aria-selected={active} onClick={() => onChange(tab.id)} className={`relative px-4 py-3 text-sm font-bold transition-colors sm:px-6 sm:text-base ${active ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-1815" data-mp="2fychbzxzbivt">
            {tab.label}
            {tab.id === 'build' && buildHasWork && !active && <span aria-label="You have a pathway in progress" className="ml-1.5 inline-block h-1.5 w-1.5 align-middle rounded-full bg-[#DB3725]" data-id="element-1816" data-mp="2qms5djcff2ey" />}
            {active && <span className="absolute -bottom-px left-0 right-0 h-1 bg-[#DB3725]" data-id="element-1817" data-mp="1y07d8go4mmac" />}
          </button>;
    })}
    </div>;
}